const PUBLIC_ANONYMOUS_SESSION_OPTIONAL_EXACT_PATHS = new Set([
  "/",
  "/home",
  "/HomePage",
  "/como-funciona",
  "/mapa-do-site",
  "/contato",
  "/termos-de-uso-e-politica-de-privacidade",
  "/blog",
  "/contos-eroticos",
  "/indicacao",
]);

const PUBLIC_ANONYMOUS_SESSION_OPTIONAL_PREFIXES = [
  "/blog/",
  "/contos-eroticos/",
  "/acompanhantes-virtuais",
  "/mapa-do-site/",
  "/indicacao/",
];

const PUBLIC_PROFILE_EXACT_EXCLUSIONS = new Set([
  "/musa/profile",
  "/musa/profile-setup",
  "/musa/dashboard",
]);

const PUBLIC_PROFILE_PREFIX_EXCLUSIONS = [
  "/musa/profile-setup/",
  "/musa/dashboard/",
];

const PUBLIC_PAGE_FOOTER_EXACT_PATHS = new Set([
  "/",
  "/home",
  "/HomePage",
  "/como-funciona",
  "/mapa-do-site",
  "/contato",
  "/termos-de-uso-e-politica-de-privacidade",
  "/blog",
  "/contos-eroticos",
  "/indicacao",
]);

const PUBLIC_PAGE_FOOTER_PREFIXES = [
  "/acompanhantes-virtuais",
  "/blog/",
  "/contos-eroticos/",
  "/mapa-do-site/",
  "/indicacao/",
];

const PUBLIC_PAGE_FOOTER_EXACT_EXCLUSIONS = new Set([
  "/login",
  "/cadastro",
  "/cadastro-acompanhante",
  "/cadastro-email-musa",
  "/cadastro-musa-phone",
  "/cadastro-musa-phone-reserva",
  "/cadastro-dados-e-senha-musa",
  "/cadastro-documento-musa",
  "/dashboard",
  "/perfilCliente",
  "/perfilMusa",
  "/cliente/profile-setup",
  "/musa/profile",
  "/musa/profile-setup",
  "/musa/dashboard",
  "/pagamentos",
  "/favoritos",
  "/stories",
  "/conteudos",
  "/conteudos/criar",
  "/deactivate-account",
  "/delete-account",
  "/blog/admin",
  "/contos-eroticos/admin",
]);

const PUBLIC_PAGE_FOOTER_PREFIX_EXCLUSIONS = [
  "/blog/admin/",
  "/contos-eroticos/admin/",
  "/cliente/profile-setup/",
  "/musa/profile-setup/",
  "/musa/dashboard/",
  "/staff/",
  "/conteudos/",
];

export function normalizePathname(pathname = "/") {
  if (!pathname || pathname === "/") return "/";
  const normalized = String(pathname).replace(/\/+$/, "");
  return normalized || "/";
}

export function isPublicVirtualListingRoute(pathname = "/") {
  const normalized = normalizePathname(pathname);
  return (
    normalized === "/acompanhantes-virtuais" ||
    normalized.startsWith("/acompanhantes-virtuais/")
  );
}

export function isPublicProfileRoute(pathname = "/") {
  const normalized = normalizePathname(pathname);

  if (!normalized.startsWith("/musa/")) return false;
  if (PUBLIC_PROFILE_EXACT_EXCLUSIONS.has(normalized)) return false;

  return !PUBLIC_PROFILE_PREFIX_EXCLUSIONS.some((prefix) => {
    const cleanPrefix = normalizePathname(prefix);
    return normalized === cleanPrefix || normalized.startsWith(`${cleanPrefix}/`);
  });
}

export function isAnonymousPublicShellRoute(pathname = "/") {
  const normalized = normalizePathname(pathname);

  if (isPublicProfileRoute(normalized)) {
    return true;
  }

  if (PUBLIC_ANONYMOUS_SESSION_OPTIONAL_EXACT_PATHS.has(normalized)) {
    return true;
  }

  return PUBLIC_ANONYMOUS_SESSION_OPTIONAL_PREFIXES.some((prefix) => {
    const cleanPrefix = normalizePathname(prefix);
    return normalized === cleanPrefix || normalized.startsWith(`${cleanPrefix}/`);
  });
}

export function isPublicShellInteractiveRoute(pathname = "/") {
  const normalized = normalizePathname(pathname);
  if (isPublicProfileRoute(normalized)) return true;
  if (normalized === "/indicacao") return true;
  return isPublicVirtualListingRoute(normalized);
}

export function isAnonymousSessionOptionalRoute(pathname = "/") {
  return isAnonymousPublicShellRoute(pathname);
}

export function shouldShowPublicPageFooter(pathname = "/") {
  const normalized = normalizePathname(pathname);

  if (PUBLIC_PAGE_FOOTER_EXACT_EXCLUSIONS.has(normalized)) {
    return false;
  }

  const isExcludedPrefix = PUBLIC_PAGE_FOOTER_PREFIX_EXCLUSIONS.some((prefix) => {
    const cleanPrefix = normalizePathname(prefix);
    return normalized === cleanPrefix || normalized.startsWith(`${cleanPrefix}/`);
  });
  if (isExcludedPrefix) return false;

  if (isPublicProfileRoute(normalized)) {
    return true;
  }

  if (PUBLIC_PAGE_FOOTER_EXACT_PATHS.has(normalized)) {
    return true;
  }

  return PUBLIC_PAGE_FOOTER_PREFIXES.some((prefix) => {
    const cleanPrefix = normalizePathname(prefix);
    return normalized === cleanPrefix || normalized.startsWith(`${cleanPrefix}/`);
  });
}
